"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportWebP = void 0;
var supportWebP = function () {
    var _a, _b;
    try {
        return (((_b = (_a = document === null || document === void 0 ? void 0 : document.createElement("canvas")) === null || _a === void 0 ? void 0 : _a.toDataURL("image/webp")) === null || _b === void 0 ? void 0 : _b.indexOf("data:image/webp")) === 0);
    }
    catch (err) {
        return false;
    }
};
exports.supportWebP = supportWebP;
